function normalizeText(value) {
  return String(value == null ? '' : value).trim()
}

function collectFieldNames(fields = [], output = []) {
  ;(fields || []).forEach((field) => {
    if (!field || field.visible === false) return
    if (field.type === 'field_row') {
      collectFieldNames(field.parts || [], output)
      return
    }
    if (field.type === 'checkbox-group') {
      collectFieldNames(field.options || [], output)
      return
    }
    if (['button', 'text', 'system', 'logicReference', 'literal'].includes(field.type)) return
    const name = normalizeText(field.label || field.variable || field.name || field.binding)
    if (name && !output.includes(name)) output.push(name)
  })
  return output
}

function diagnosticQuestion(diagnostic = {}) {
  const code = normalizeText(diagnostic.code || diagnostic.kind || 'SST')
  const message = normalizeText(diagnostic.message || diagnostic.title || diagnostic.raw)
  if (!message) return ''
  const line = Number(diagnostic.line || diagnostic.sourceLine || 0)
  return `[${code}] ${message}${line > 0 ? ` (línea ${line})` : ''}`
}

/**
 * Proyecta el IR canónico del convertidor al contrato de revisión que antes
 * producía Agente 1. Es determinista: no llama IA ni modifica los artefactos
 * data.json/logic.json que se usarán al confirmar la importación.
 */
export function buildDeterministicSstReviewIR(conversion = {}, options = {}) {
  const sourceIr = conversion.ir && typeof conversion.ir === 'object' ? conversion.ir : {}
  const stats = conversion.stats || {}
  const logicJson = conversion.logicJson || {}
  const fileName = normalizeText(options.fileName || conversion.source?.fileName || 'script.sst')
  const title = normalizeText(sourceIr.title || conversion.dataJson?.title || fileName) || fileName
  const formTitles = (sourceIr.forms || [])
    .map((form) => normalizeText(form?.title || form?.id || form?.legacyId))
    .filter(Boolean)
  const menuTitles = (sourceIr.menus || [])
    .map((menu) => normalizeText(menu?.title || menu?.id || menu?.key))
    .filter(Boolean)
  const inputNames = (sourceIr.forms || []).reduce(
    (names, form) => collectFieldNames(form?.fields || [], names),
    [],
  )
  const entryBlock = normalizeText(logicJson.entryBlock)
  const summaryParts = [
    `Interpretación determinista de ${fileName}.`,
    `Se detectaron ${Number(stats.forms || formTitles.length)} ventana(s), ${Number(stats.menus || menuTitles.length)} menú(s), ${Number(stats.blocks || Object.keys(logicJson.blocks || {}).length)} bloque(s) y ${Number(stats.actions || 0)} acción(es).`,
  ]
  if (entryBlock) summaryParts.push(`El flujo inicia en ${entryBlock}.`)
  if (menuTitles.length) summaryParts.push(`Menús: ${menuTitles.slice(0, 8).join(', ')}${menuTitles.length > 8 ? '…' : ''}.`)
  if (formTitles.length) summaryParts.push(`Ventanas principales: ${formTitles.slice(0, 8).join(', ')}${formTitles.length > 8 ? '…' : ''}.`)
  summaryParts.push('La navegación, condiciones, CALL/GOTO y comandos detectados se conservan en logic.json para la ejecución del paquete SST.')
  const summary = summaryParts.join(' ')
  const diagnosticQuestions = (conversion.diagnostics || [])
    .filter((diagnostic) => ['warning', 'error', 'fatal'].includes(normalizeText(diagnostic?.level || diagnostic?.severity).toLowerCase()))
    .map(diagnosticQuestion)
    .filter(Boolean)
    .slice(0, 12)

  return {
    ...sourceIr,
    title,
    summary,
    meta: {
      ...(sourceIr.meta && typeof sourceIr.meta === 'object' ? sourceIr.meta : {}),
      title,
      summary,
      inputs: inputNames.slice(0, 30).join(', '),
      writes: `${Number(stats.actions || 0)} acción(es) preservadas en logic.json`,
      does_not: 'La interpretación no ejecuta comandos Sabre ni consume agentes de IA.',
    },
    source: {
      ...(sourceIr.source && typeof sourceIr.source === 'object' ? sourceIr.source : {}),
      kind: 'sst',
      confidence: diagnosticQuestions.length ? 'medium' : 'high',
      interpreter: 'boston-sst-converter-v1',
      fileName,
    },
    open_questions: diagnosticQuestions,
    converter: {
      version: conversion.version?.integration || 'boston-sst-converter-v1',
      stats,
      deterministic: true,
    },
  }
}

